import { render, staticRenderFns } from "./externalTempatTidur.vue?vue&type=template&id=2d1abb12"
import script from "./externalTempatTidur.vue?vue&type=script&lang=js"
export * from "./externalTempatTidur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1abb12')) {
      api.createRecord('2d1abb12', component.options)
    } else {
      api.reload('2d1abb12', component.options)
    }
    module.hot.accept("./externalTempatTidur.vue?vue&type=template&id=2d1abb12", function () {
      api.rerender('2d1abb12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalTempatTidur.vue"
export default component.exports